import { LearnerProfileByIdQuery } from '@/__generated__/graphql';
import { DinRoundProFont } from '@/lib/utils';
import time from '@flyer/utils/time';
import useTranslation from 'next-translate/useTranslation';
import { useEffect, useRef } from 'react';
import { twMerge } from 'tailwind-merge';

function ProfileUserAttempt({
  userAttempt,
  fetchMoreAttempts,
}: {
  userAttempt?: NonNullable<LearnerProfileByIdQuery['learnerProfile']>['userAttempts'];
  fetchMoreAttempts: () => void;
}) {
  const scrollRef = useRef<HTMLDivElement>(null);

  const { t, lang } = useTranslation('common');

  useEffect(() => {
    const handleScroll = () => {
      if (scrollRef.current) {
        const { scrollTop, scrollHeight, clientHeight } = scrollRef.current;
        const bottomThreshold = 20;
        if (scrollHeight - scrollTop - clientHeight < bottomThreshold) {
          fetchMoreAttempts();
        }
      }
    };

    const scrollContainer = scrollRef.current;
    if (scrollContainer) {
      scrollContainer.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (scrollContainer) {
        scrollContainer.removeEventListener('scroll', handleScroll);
      }
    };
  }, [fetchMoreAttempts]);

  return (
    <div className={twMerge('flex flex-col w-full', DinRoundProFont.className)}>
      <div className="flex flex-col -mx-4">
        <div className="flex flex-row bg-[#F5F5F5] px-6 py-4">
          <div className="w-[60%] text-left text-[#8D8D8D] text-[15px] font-bold">
            {t('ranking.test_name')}
          </div>
          <div className="w-[20%] text-left text-[#8D8D8D] text-[15px] font-bold">
            {t('ranking.submit_time')}
          </div>
          <div className="w-[20%] text-center text-[#8D8D8D] text-[15px] font-bold">
            {t('ranking.scores')}
          </div>
        </div>
        <div ref={scrollRef} className="overflow-y-scroll px-6 flex flex-col gap-2 max-h-[310px]">
          {userAttempt?.edges?.map((item) => {
            const testName =
              lang === 'en' && item.node.checkPoint?.nameEn
                ? `${item.node.checkPoint?.nameEn}`
                : item.node.checkPoint?.name;
            return (
              <div key={item.node.id} className="text-[#000000] flex flex-row pt-2">
                <div className="w-[60%] text-left">
                  <span>{testName}</span>
                </div>
                <div className="w-[20%] text-left">
                  <span>{time(item.node?.submittedAt).format('DD-MM-YYYY') || '--'}</span>
                </div>
                <div className="w-[20%] text-center">
                  <span>
                    {item.node.grade}/{item.node.maxGrade}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default ProfileUserAttempt;
